import AjaxForm from './components/AjaxForm';
import Slide from './components/Slide';

export const components = {
    'form.AjaxForm': AjaxForm,
    '.main' : Slide
};



// WEBPACK FOOTER //
// ./src/js/components.js